import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ConsultationSessionService } from '@services/consultation-session-service';
import { LoadingModule } from '@components/loading';
import { ConnectionService } from '@services/connection-service';

@Component({
  selector: 'submit-default-answers',
  imports: [LoadingModule],
  templateUrl: './submit-default-answers.component.html',
})
export class SubmitDefaultAnswersComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly consultationSessionService = inject(ConsultationSessionService);
  private readonly connectionService = inject(ConnectionService);

  ngOnInit(): void {
    this.processSubmitDefaultAnswers();
  }

  private async processSubmitDefaultAnswers(): Promise<void> {
    const consultationSession = this.consultationSessionService.getPendingConsultationSession();

    if (!consultationSession) {
      this.router.navigate(['/user'], { queryParams: { tab: 'home' } });
      return;
    }
    const user = this.connectionService.getActingUser();
    const userAge = user?.get('Age');
    await this.consultationSessionService.submitDefaultAnswersAndNavigateToRegimenPage(consultationSession, userAge);
  }
}

